import { MDTApi } from './mdtapi.js';

export const getFeatureConfiguration = (territoryId, countryId, appid) => {
    const params = {
        app: appid,
        ...(!!territoryId && { territoryId }),
        ...(!!countryId && { countryId }),
    };

    return MDTApi.call('api.forms.featuresConfigured', {
        method: 'GET',
        params,
    });
};

export const getDownloadHideConfig = () => {
    return MDTApi.call('api.forms.downloadHide', {
        method: 'GET',
        setBuidSiteIdInHeader: true,
        headers: {
            Authorization: '',
        },
    });
};

export const getDefaultCustomer = () => {
    return MDTApi.call('api.login.defaultCustomer', {
        method: 'GET',
    });
};

export const getDefaultContract = () => {
    return MDTApi.call('api.login.defaultContract', {
        method: 'GET',
    });
};

export const getUserPermissions = (customerid) => {
    return MDTApi.call(
        'api.login.userPermissions',
        {
            method: 'GET',
        },
        {
            customerId: customerid,
        }
    );
};

export const getUserInfoCall = () => {
    return MDTApi.call(
        'api.login.userinfo',
        {
            method: 'GET',
        },
        {},
        !window.showloaderFirstTime
    );
};

export const getUserDetails = () => {
    return MDTApi.call(
        'api.profile.profile',
        {
            method: 'GET',
        },
        {},
        false
    );
};

export const getCustomerInfoCall = () => {
    const fetchCutomerApi = 'api.customer.v1.searchCustomers';
    const isCustomerSource = !(
        window.octopusFeatures && window.octopusFeatures.isCustomerSource === 'false'
    );
    const includeInactive = !!(
        window.octopusFeatures && window.octopusFeatures.includeInactive === 'true'
    );

    return MDTApi.call(
        fetchCutomerApi,
        {
            method: 'POST',
            data: {
                searchText: '',
                pageSize: 10,
                isCustomerSource,
                includeInactive,
                sort: 'name.raw',
            },
        },
        {}
    );
};

export const getCountryList = () => {
    return MDTApi.call('api.common.countries', {
        method: 'GET',
    });
};

export const fetchAPINotificationPreferencesList = () => {
    const params = {
        basesite: window.MDTSetting.basesiteid,
        bu: window.MDTSetting.buid,
        app: window.MDTSetting.appid || window.appSettings.appid,
    };
    return MDTApi.call('api.notifications.notificationPreferencesList', {
        method: 'GET',
        params,
    });
};

export const autoOnboard = async () => {
    return new Promise((resolve, reject) => {
        MDTApi.call(
            'api.accountSetup.autoOnboarding',
            {
                method: 'POST',
                successCallback: (response) => {
                    resolve(response);
                },
                errorCallback: (error) => {
                    reject(error);
                },
            },
            {}
        );
    });
};
